export default function genererCritereRechercheEmplacement() {
  return {
    villes: [],
    villesDispositif: [],
    villesEmplacement: [],
    agglomerations: [],
    codes: [],
    auto: null,
    agencesId: [],
    adresse: null,
    actif: true,
    formats: [],
    codesPostaux: [],
    domaine: null,
    eclaire: null,
    avecCoordonnees: null,
    typesMateriels: [],
    clientIds: [],
    clients: [],
    secteurs: [],
  };
}
